// // Power Reviews: Convert rating count span to anchor for products with 0 reviews
// (function() {
//   let listenerAttached = false;  // Flag to prevent duplicate listeners
  
//   function linkReviewCount() {
//     const span = document.querySelector('.pr-snippet-rating-count');
//     const reviewDisplay = document.querySelector('[data-testid="review-display"]');
//     const anchorId = reviewDisplay?.id || 'pr-reviewdisplay';
    
//     // Only convert span to a if it's not already wrapped/linked
//     if (span && !span.closest('a')) {
//       const a = document.createElement('a');
//       a.href = `#${anchorId}`;
//       a.className = span.className;
//       a.textContent = span.textContent;
      
//       Array.from(span.attributes).forEach(attr => {
//         if (attr.name.startsWith('data-')) {
//           a.setAttribute(attr.name, attr.value);
//         }
//       });
      
//       span.replaceWith(a);
//     }
    
//     // Only attach listener ONCE per page load
//     if (!listenerAttached) {
//       const anchor = document.querySelector('a.pr-snippet-rating-count');
      
//       if (anchor) {
//         anchor.addEventListener('click', function(e) {
//           e.preventDefault();
//           e.stopPropagation();
//           e.stopImmediatePropagation();

//           const target = document.getElementById(anchorId);
//           if (target) {
//             setTimeout(() => {
//               const reviewSnapshot = document.querySelector('[data-testid="review-snapshot"]');
//               const snapshotHeight = reviewSnapshot ? reviewSnapshot.offsetHeight : 0;
              
//               const rect = target.getBoundingClientRect();
//               const scrollTop = window.scrollY || document.documentElement.scrollTop;
//               const targetPosition = rect.top + scrollTop;
              
//               // Detect scenario - check for actual review content
//               const hasEnhancement = document.querySelector('.slb-pr-enhancement-wrapper');
//               const snippetRatingCounts = document.querySelectorAll('.pr-snippet-rating-count');
//               const secondRatingCount = snippetRatingCounts.length > 1 ? snippetRatingCounts[1] : null;
//               const hasReviews = secondRatingCount && secondRatingCount.textContent !== 'No Ratings';
//               const hasHistogram = document.querySelector('.pr-review-snapshot-histogram');

//               // Determine screen size
//               const screenWidth = window.innerWidth;
//               const isMobile = screenWidth < 768;
//               const isTablet = screenWidth >= 768 && screenWidth < 1024;
//               const isDesktop = screenWidth >= 1024;

//               console.log('Screen width:', screenWidth, '| Mobile:', isMobile, '| Tablet:', isTablet, '| Desktop:', isDesktop);

//               let offset;
//               if (hasEnhancement) {
//                 offset = isMobile ? -200 : -120;
//                 console.log('********* option 1 (No Reviews & No Rating) *********');
//                 console.log('isMobile ', isMobile, ' isTablet ', isTablet, ' isDesktop ', isDesktop);

//               } else if (hasReviews && hasHistogram) {
//                 offset = isMobile ? 900 : (isTablet ? 400 : 450);
//                 console.log('********* option 2 (Reviews & Rating) *********');
//                 console.log('isMobile ', isMobile, ' isTablet ', isTablet, ' isDesktop ', isDesktop);
//               } else if (!hasReviews && !hasEnhancement) {
//                 offset = isMobile ? 250 : (isTablet ? 150 : 250);
//                 console.log('********* option 3 (No Reviews & Rating) *********');
//                 console.log('isMobile ', isMobile, ' isTablet ', isTablet, ' isDesktop ', isDesktop);
//               } else {
//                 offset = 250;
//                 console.log('********* DEFAULT *********');
//               }
              
//               console.log('Final offset:', offset);
              
//               window.scrollTo({
//                 top: targetPosition - snapshotHeight + offset,
//                 behavior: 'smooth'
//               });
//             }, 300);
//           }
//         }, true);
        
//         listenerAttached = true;  // Prevent attaching again
//       }
//     }
//   }

//   // Watch for PR initialization/updates
//   const observer = new MutationObserver(() => {
//     const reviewSnippet = document.querySelector('#pr-reviewsnippet[data-pr-mounted="true"]');
//     if (reviewSnippet) {
//       linkReviewCount();
//     }
//   });

//   observer.observe(document.body, { childList: true, subtree: true });
// })();

// Power Reviews: Convert rating count span to anchor for products with 0 reviews
(function() {
  let listenerAttached = false;
  
  function linkReviewCount() {
    const span = document.querySelector('.pr-snippet-rating-count');
    // const reviewDisplay = document.querySelector('[data-testid="review-display"]');
    // const anchorId = reviewDisplay?.id || 'pr-reviewdisplay';
    const anchorId = 'pr-reviewdisplay';
    
    // Only convert span to a if it's not already wrapped/linked
    if (span && !span.closest('a')) {
      const a = document.createElement('a');
      a.href = `#${anchorId}`;
      a.className = span.className;
      a.textContent = span.textContent;
      
      Array.from(span.attributes).forEach(attr => {
        if (attr.name.startsWith('data-')) {
          a.setAttribute(attr.name, attr.value);
        }
      });
      
      span.replaceWith(a);
    }
    
    // Only attach listener ONCE per page load
    if (!listenerAttached) {
      const anchor = document.querySelector('a.pr-snippet-rating-count');
      
      if (anchor) {
        anchor.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          const target = document.getElementById(anchorId);
          if (target) {
            // Wait for page to settle, then scroll target into view
            setTimeout(() => {
              const target = document.getElementById(anchorId);
              if (target) {
                console.log('Target element found:', target);
                console.log('Calling scrollIntoView()');
                target.scrollIntoView({ 
                  behavior: 'smooth', 
                  block: 'start'
                });
              } else {
                console.log('Target element NOT found with ID:', anchorId);
              }
            }, 200);
          }
        }, true);
        
        listenerAttached = true;
      }
    }
  }

  // Watch for PR initialization/updates
  const observer = new MutationObserver(() => {
    const reviewSnippet = document.querySelector('#pr-reviewsnippet[data-pr-mounted="true"]');
    if (reviewSnippet) {
      linkReviewCount();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();